module.exports = __webpack_public_path__ + "static/media/webdesign-services-img12.ff630e19.jpg";